import {
    CLEAR_OPPONENT_SELECTION,
    COMPANY_OPPONENT_STATISTICS_FETCH,
    COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS,
    COMPANY_SEARCH_RESULT_SUCCESS,
    COMPANY_STATISTICS_FETCH,
    COMPANY_STATISTICS_FETCH_SUCCESS,
    COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS,
    COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS,
    DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY,
    DRUG_FETCH_SUCCESSFULLY,
    DRUG_LOADING,
    DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY,
    DRUGS_COUNTRY_ATC,
    DRUGS_FETCH_SUCCESSFULLY,
    DRUGS_LOADING
} from "../actions/actionTypes";

const drugReducer = (state = {}, action) => {
    switch (action.type) {
        case DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY:
            return {
                ...state,
                drugsPerCountry: action.payload.drugsPerCountry,
                drugsCount: action.payload.drugsCount,
                countriesCovered: action.payload.countriesCovered
            };
        case DRUGS_COUNTRY_ATC:
            return {
                ...state,
                drugsForCountryPerATC: action.payload
            }
        case DRUGS_LOADING:
            return {
                ...state,
                loading: true,
                drugs: []
            };
        case DRUGS_FETCH_SUCCESSFULLY:
            return {
                ...state,
                drugs: action.payload.drugs,
                totalDrugs: action.payload.totalDrugs,
                loading: false
            };
        case DRUG_LOADING:
            return {
                ...state,
                loading: true
            };
        case DRUG_FETCH_SUCCESSFULLY:
            return {
                ...state,
                drug: action.payload,
                loading: false
            };
        case COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS:
            return {
                ...state,
                count_per_countries_by_active_substance: action.payload
            };
        case COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS:
            return {
                ...state,
                count_per_countries_by_brand_name: action.payload
            };
        case DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY:
            return {
                ...state,
                drugsCountPerManufacturer: action.payload
            };
        case COMPANY_SEARCH_RESULT_SUCCESS:
            return {
                ...state,
                searchResult: action.payload
            };
        case COMPANY_STATISTICS_FETCH:
            return {
                ...state,
                loadingCompanyStatistics: true
            };
        case COMPANY_STATISTICS_FETCH_SUCCESS:
            return {
                ...state,
                loadingCompanyStatistics: false,
                companyStatistics: action.payload
            };
        case COMPANY_OPPONENT_STATISTICS_FETCH:
            return {
                ...state,
                loadingCompanyOpponentStatistics: true
            };
        case COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS:
            return {
                ...state,
                loadingCompanyOpponentStatistics: false,
                companyOpponentStatistics: action.payload
            };
        case CLEAR_OPPONENT_SELECTION:
            return {
                ...state,
                companyOpponentStatistics: null,
                countryCode: null,
            };
        default:
            return state;
    }
};

export default drugReducer;
